import React, { useState } from 'react';
import { Form, Switch } from 'antd';

import {
  ActivityExtendedField,
  ExtendedFieldValue,
} from '@totem/components/ticketing/ticketing';

const FormItem = Form.Item;

import '../../ticketing.css';

const styles = {
  form: {
    width: '100%',
  },
  formItem: {
    paddingBottom: '0',
    marginBottom: '1rem',
  },
};

type Props = {
  extendedField: ActivityExtendedField;
  extendedFieldValue: ExtendedFieldValue;
  onChange: (name: string, value: string, id: string, isValid: boolean) => void;
};

const ExtendedFieldBoolean = ({
  extendedField,
  extendedFieldValue,
  onChange,
}: Props) => {
  const [selectedValue, setSelectedValue] = useState<boolean>(
    extendedFieldValue !== null
      ? extendedFieldValue.value.toLowerCase() === 'true'
      : false,
  );

  const handleChange = (isChecked: boolean) => {
    setSelectedValue(isChecked);

    onChange(extendedField.name, isChecked.toString().toLowerCase(), '', true);
  };

  return (
    <FormItem
      label={extendedField.label}
      colon={false}
      style={styles.formItem}
      validateStatus={extendedFieldValue.isValid ? 'success' : 'error'}
    >
      <Switch onChange={handleChange} checked={selectedValue} />
    </FormItem>
  );
};

export default ExtendedFieldBoolean;
